export interface OrderItem {
  id: string;
  productId: string;
  name: string;
  price: number;
  quantity: number;
  image: string;
}

export interface Order {
  id: string;
  date: string;
  status: 'processing' | 'shipped' | 'delivered' | 'cancelled';
  total: number;
  items: OrderItem[];
  shippingAddress: string;
  paymentMethod: string;
  trackingNumber?: string;
}

export const mockOrders: Order[] = [
  {
    id: 'ORD-2023-1001',
    date: '2023-10-25T14:30:00Z',
    status: 'delivered',
    total: 4500,
    items: [
      {
        id: '1',
        productId: '1',
        name: 'Organic Tomatoes',
        price: 150,
        quantity: 10,
        image: 'https://images.unsplash.com/photo-1592924357228-91a4daadcfea?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dG9tYXRvZXMlMjBwbGFudHxlbnwwfHwwfHx8MA%3D%3D'
      },
      {
        id: '2',
        productId: '3',
        name: 'Fresh Spinach',
        price: 50,
        quantity: 5,
        image: 'https://images.unsplash.com/photo-1576045057995-568f588f82fb?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c3BpbmFjaHxlbnwwfHwwfHx8MA%3D%3D'
      }
    ],
    shippingAddress: '123 Green Lane, Nairobi, Kenya',
    paymentMethod: 'M-PESA',
    trackingNumber: 'TRK-889900'
  },
  {
    id: 'ORD-2023-1005',
    date: '2023-11-02T09:15:00Z',
    status: 'shipped',
    total: 2800,
    items: [
      {
        id: '3',
        productId: '2',
        name: 'Yellow Maize',
        price: 1200,
        quantity: 2,
        image: 'https://images.unsplash.com/photo-1551754655-cd27e38d2076?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bWFpemV8ZW58MHx8MHx8fDA%3D'
      }
    ],
    shippingAddress: '456 Farm Road, Nakuru, Kenya',
    paymentMethod: 'Credit Card',
    trackingNumber: 'TRK-990011'
  },
  {
    id: 'ORD-2023-1010',
    date: '2023-11-05T16:45:00Z',
    status: 'processing',
    total: 1200,
    items: [
      {
        id: '4',
        productId: '5',
        name: 'Red Onions',
        price: 80,
        quantity: 15,
        image: 'https://images.unsplash.com/photo-1618512496248-a07fe83aa8cb?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cmVkJTIwb25pb25zfGVufDB8fDB8fHww'
      }
    ],
    shippingAddress: '123 Green Lane, Nairobi, Kenya',
    paymentMethod: 'M-PESA'
  }
];
